/* eslint-disable */
export default {
  adafruit_gfx: {
    name: "Adafruit GFX Library",
    url:
      "https://downloads.arduino.cc/libraries/github.com/adafruit/Adafruit_GFX_Library-1.10.10.zip",
    version: "latest"
  },
  adafruit_led_backpack: {
    name: "Adafruit LED Backpack Library",
    url:
      "https://downloads.arduino.cc/libraries/github.com/adafruit/Adafruit_LED_Backpack_Library-1.1.9.zip",
    version: "latest"
  },
  adafruit_busio: {
    name: "Adafruit BusIO",
    url: "https://downloads.arduino.cc/libraries/github.com/adafruit/Adafruit_BusIO-1.8.2.zip",
    version: "latest"
  },
  adafruit_neopixel: {
    name: "Adafruit NeoPixel",
    url: "https://downloads.arduino.cc/libraries/github.com/adafruit/Adafruit_NeoPixel-1.8.3.zip",
    version: "latest"
  },
  servo: {
    name: "Servo",
    url: "https://downloads.arduino.cc/libraries/github.com/arduino-libraries/Servo-1.1.8.zip",
    version: "latest"
  },
  ir_remote: {
    name: "IRremote",
    url: "https://downloads.arduino.cc/libraries/github.com/z3t0/IRremote-3.3.0.zip",
    version: "latest"
  },
  sd: {
    name: "SD",
    url: "https://downloads.arduino.cc/libraries/github.com/arduino-libraries/SD-1.2.4.zip",
    version: "latest"
  },
  sd_fat: {
    name: "SdFat",
    url: "https://downloads.arduino.cc/libraries/github.com/greiman/SdFat-2.1.0.zip",
    version: "latest"
  },
  rtc: {
    name: "RTClib",
    url: "https://downloads.arduino.cc/libraries/github.com/adafruit/RTClib-1.14.1.zip",
    version: "latest"
  },
  stepper: {
    name: "Stepper",
    url: "https://downloads.arduino.cc/libraries/github.com/arduino-libraries/Stepper-1.1.3.zip",
    version: "latest"
  },
  dht: {
    name: "DHT sensor library",
    url: "https://downloads.arduino.cc/libraries/github.com/adafruit/DHT_sensor_library-1.4.2.zip",
    version: "latest"
  },
  servo_osc: {
    name: "ServoOsc",
    url: "https://downloads.arduino.cc/libraries/github.com/fitzterra/ServoOsc-1.2.0.zip",
    version: "latest"
  },
  blynk: {
    name: "Blynk",
    url: "https://downloads.arduino.cc/libraries/github.com/blynkkk/Blynk-1.0.0.zip",
    version: "latest"
  },
  median_filter: {
    name: "MedianFilterLib2",
    url: "https://downloads.arduino.cc/libraries/github.com/warhog/MedianFilterLib2-1.0.0.zip",
    version: "latest"
  },
  adafruit_sensor: {
    name: "Adafruit Unified Sensor",
    url: "https://downloads.arduino.cc/libraries/github.com/adafruit/Adafruit_Unified_Sensor-1.1.4.zip",
    version: "latest"
  }
};
